import type { ReactNode } from 'react';

import { Button } from '@/components/ui/button.js';

export interface HintActionFooterProps {
  onGotIt: () => void;
  onSkipTour: () => void;
}

/**
 * Shared tip footer: primary "Got it" on the right, low-emphasis "Skip all tips" on the left
 * so dismissing the whole tour is deliberate and not confused with closing this tip only.
 */
export function HintActionFooter({
  onGotIt,
  onSkipTour,
}: HintActionFooterProps): ReactNode {
  return (
    <div className="flex items-center justify-between gap-3">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="text-muted-foreground hover:text-foreground"
        onClick={onSkipTour}
      >
        Skip all tips
      </Button>
      <Button type="button" onClick={onGotIt}>
        Got it
      </Button>
    </div>
  );
}
